import { TYPE_LABELS, formatMoney, formatNumber, typeOfApi } from './campaign-rule';

// The list's Offer column (handoff §6): line 1 the offer, line 2 the type.
// A free item names its product (spec §2.2, `freeitemproductname`), not the
// mock's "Free item". A null discounttype is Fixed (the api's default).
export const offerLines = (coupon) => {
  const type = typeOfApi(coupon?.type);
  if (type === 'discount') {
    const offer =
      coupon.discounttype === 0
        ? `${formatNumber(coupon.discountamount)}% off`
        : `${formatMoney(coupon.discountamount)} off`;
    return { offer, kind: TYPE_LABELS.discount };
  }
  if (type === 'free_item') {
    return {
      offer: coupon.freeitemproductname ? `Free ${coupon.freeitemproductname}` : 'Free item',
      kind: TYPE_LABELS.free_item,
    };
  }
  if (type === 'buy_x_get_y') {
    return {
      offer: `Buy ${coupon.buyItemCount ?? 1}, get ${coupon.getItemCount ?? 1} free`,
      kind: TYPE_LABELS.buy_x_get_y,
    };
  }
  return { offer: '', kind: '' };
};
